export default "__VITE_ASSET__739saAG0__"